var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHero(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1269,
    height: 426,
    viewBox: "0 0 1269 426",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M792.303 220.081C788.692 215.938 788.692 209.767 792.303 205.624L967.386 4.772C969.475 2.37551 972.498 1.00002 975.677 1.00002L1077.44 1.00004C1086.88 1.00004 1091.94 12.1112 1085.74 19.228L924.403 204.31C920.135 209.206 920.135 216.499 924.403 221.395L1085.74 406.474C1091.94 413.591 1086.88 424.702 1077.44 424.702L975.677 424.702C972.498 424.702 969.475 423.327 967.385 420.93L792.303 220.081Z",
    stroke: "white",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M957.3 220.081C953.689 215.938 953.689 209.767 957.3 205.625L1132.38 4.77206C1134.47 2.37551 1137.49 1.00002 1140.67 1.00002L1242.44 1.00004C1251.88 1.00004 1256.94 12.1113 1250.73 19.228L1089.4 204.31C1085.13 209.206 1085.13 216.499 1089.4 221.395L1250.73 406.474C1256.94 413.591 1251.88 424.702 1242.44 424.702L1140.67 424.702C1137.49 424.702 1134.47 423.327 1132.38 420.93L957.3 220.081Z",
    stroke: "white",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M476.488 205.621C480.099 209.764 480.099 215.935 476.488 220.078L301.405 420.93C299.316 423.326 296.293 424.702 293.114 424.702L191.347 424.702C181.907 424.702 176.852 413.591 183.056 406.474L344.388 221.392C348.656 216.496 348.656 209.203 344.388 204.307L183.056 19.228C176.852 12.1113 181.907 1.00002 191.348 1.00002L293.114 1.00002C296.293 1.00002 299.316 2.37548 301.406 4.77194L476.488 205.621Z",
    stroke: "white",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M311.519 205.621C315.13 209.764 315.13 215.935 311.519 220.077L136.438 420.93C134.349 423.326 131.325 424.702 128.146 424.702L26.3789 424.702C16.9379 424.702 11.8834 413.591 18.087 406.474L179.422 221.392C183.689 216.496 183.689 209.203 179.421 204.307L18.0873 19.228C11.8836 12.1113 16.9381 0.999987 26.3792 0.999987L128.146 0.999992C131.325 0.999992 134.349 2.37546 136.438 4.77194L311.519 205.621Z",
    stroke: "white",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHero);
export default __webpack_public_path__ + "static/media/hero.b2b4f96a9e284a35c5a2bbeaacd7bbaf.svg";
export { ForwardRef as ReactComponent };